import { FiAlertCircle, FiShieldOff } from "react-icons/fi";
import { Tooltip as ReactTooltip } from "react-tooltip";
import useTranslator from "../../hooks/useTranslator";
import { INSURANCE_REPORT_STATUS } from "../../Utils/insuranceReportStatus";
import InsurabilityBadge from "./InsurabilityBadge";

const DecisionCard = ({
  decisionTitle,
  decisionStatus,
  combinedIncome,
  combinedEffortRate,
  decisionSummary,
  insurable,
  insurabilityStatus,
  insurabilityErrorCode,
  insurabilityErrorCodes = [],
  recommendedActions,
  children,
  currentLang,
  preFilledInsuranceDocument,
  insurabilityContactOnly = false,
}) => {
  // Determine the status class for styling
  const { _t } = useTranslator();
  const getStatusClass = () => {
    if (typeof decisionStatus === "string") {
      const lowerStatus = decisionStatus.toLowerCase();
      if (lowerStatus === "approved") return "approved";
      if (lowerStatus === "rejected") return "rejected";
      return "conditional";
    }
    return "conditional";
  };

  const statusClass = getStatusClass();
  const resolvedInsurabilityStatus = insurabilityContactOnly
    ? INSURANCE_REPORT_STATUS.UNDER_REVIEW
    : (insurabilityStatus ??
      (insurable === true
        ? INSURANCE_REPORT_STATUS.INSURABLE
        : insurable === false
          ? INSURANCE_REPORT_STATUS.NOT_INSURABLE
          : null));

  return (
    <section className={`linked-report__decision-card ${statusClass}`}>
      <div className="linked-report__decision-title-row">
        <div className="linked-report__decision-title">{decisionTitle}</div>
        <InsurabilityBadge
          status={resolvedInsurabilityStatus}
          errorCode={insurabilityErrorCode}
          errorCodes={insurabilityErrorCodes}
          preFilledInsuranceDocument={preFilledInsuranceDocument}
          contactOnly={insurabilityContactOnly}
        />
      </div>
      <div className="linked-report__decision-metrics">
        <strong>{`€${Math.round(combinedIncome || 0)}/${_t("mo")}`}</strong>
        <span>•</span>
        <strong>{`${_t("effortRate")} ${combinedEffortRate}`}</strong>
      </div>
      {decisionSummary && (
        <p className="linked-report__decision-description">
          {typeof decisionSummary === "string"
            ? decisionSummary
            : decisionSummary[currentLang]?.split("\n")?.join(" ") ||
              "This tenant nearly meets the criteria for automatic approval."}
        </p>
      )}
      {children}
    </section>
  );
};

export default DecisionCard;
